export default "__VITE_ASSET__CyDSuXlW__"